import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type RoleItem = { id: string; name: string };
export type OrganizationAssignment = { organizationId: number; isDefault: boolean };

export async function listRoles() {
  const { data } = await apiClient.get("/roles");
  const rows = unwrapApiResponse<RoleItem[]>(data);
  return Array.isArray(rows) ? rows : [];
}

export async function createRole(roleName: string) {
  const { data } = await apiClient.post("/roles", null, { params: { roleName } });
  return data;
}

export async function deleteRole(roleName: string) {
  const { data } = await apiClient.delete(`/roles/${encodeURIComponent(roleName)}`);
  return data;
}

export async function getUserPermissions(userId: string) {
  const { data } = await apiClient.get(`/user-permissions/${userId}`);
  const rows = unwrapApiResponse<string[]>(data);
  return Array.isArray(rows) ? rows : [];
}

export async function assignUserPermissions(userId: string, permissions: string[]) {
  const { data } = await apiClient.post("/user-permissions/assign", { userId, permissions });
  return data;
}

export async function clearUserPermissions(userId: string) {
  const { data } = await apiClient.delete(`/user-permissions/${userId}`);
  return data;
}

export async function resetUserPassword(userId: string, newPassword: string) {
  const { data } = await apiClient.post(`/users/${userId}/reset-password`, { userId, newPassword });
  return data;
}

export async function updateUserRoles(userId: string, roles: string[]) {
  const { data } = await apiClient.put(`/users/${userId}/roles`, roles);
  return data;
}

export async function toggleUserLock(userId: string) {
  const { data } = await apiClient.post(`/users/${userId}/lock-toggle`);
  return data;
}

export async function getUserOrganizations(userId: string) {
  const { data } = await apiClient.get(`/organizations/user/${userId}`);
  return data as OrganizationAssignment[];
}

export async function assignUserOrganization(organizationId: number, userId: string, isDefault: boolean) {
  const { data } = await apiClient.post(`/organizations/${organizationId}/users`, { userId, isDefault });
  return data;
}
